module.exports = __webpack_public_path__ + "senegal.svg?61d910b699d8748f56d35b9403689541";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/senegal.svg
// module id = 287
// module chunks = 10